import { render, staticRenderFns } from "./InventoryBatch.vue?vue&type=template&id=8ce476a0&scoped=true"
import script from "./InventoryBatch.vue?vue&type=script&lang=js"
export * from "./InventoryBatch.vue?vue&type=script&lang=js"
import style0 from "./InventoryBatch.vue?vue&type=style&index=0&id=8ce476a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce476a0",
  null
  
)

export default component.exports